import {
    IFulfilledPromise,
    IPendingPromise,
    IRejectedPromise,
    isPromiseBasedObservable,
    PENDING,
    FULFILLED,
    REJECTED,
} from 'mobx-utils';
import { LazyObservablePromise } from './LazyObservablePromise';

const everPendingPromise = new Promise(() => null);

function isFulfilledPromiseObservable(
    promise: unknown
): promise is IFulfilledPromise<unknown> {
    return isPromiseBasedObservable(promise) && promise.state === FULFILLED;
}

function isRejectedPromiseObservable(
    promise: unknown
): promise is IRejectedPromise {
    return isPromiseBasedObservable(promise) && promise.state === REJECTED;
}

function isPendingPromiseObservable(
    promise: unknown
): promise is IPendingPromise {
    return isPromiseBasedObservable(promise) && promise.state === PENDING;
}

function resolve<T>(value: T): LazyObservablePromise<T> {
    return LazyObservablePromise.resolve(value);
}

function reject<E extends Error>(value: E): LazyObservablePromise<never> {
    return LazyObservablePromise.reject(value);
}

function sleep(seconds: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, seconds * 1000));
}

export {
    isFulfilledPromiseObservable,
    isRejectedPromiseObservable,
    isPendingPromiseObservable,
    everPendingPromise,
    resolve,
    reject,
    sleep,
};
